import { render, staticRenderFns } from "./ProcessProfileTab.vue?vue&type=template&id=4943352c&scoped=true&"
import script from "./ProcessProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProcessProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943352c",
  null
  
)

export default component.exports